export const FULL_DATE_DASH_DATE = /^\d{4}-\d{2}-\d{2}$/;

export const MONTH_YEAR_DASH_DATE = /^\d{4}-\d{2}$/;
